export default function initFooterSocials() {
	const menu = document.querySelector( '.site-footer__socials-more' );
	if ( ! menu ) {
		return;
	}

	document.addEventListener( 'click', ( event ) => {
		if ( menu.open && ! menu.contains( event.target ) ) {
			menu.open = false;
		}
	} );

	document.addEventListener( 'keydown', ( event ) => {
		if ( event.key === 'Escape' && menu.open ) {
			const focusWasInside = menu.contains( document.activeElement );
			menu.open = false;
			if ( focusWasInside ) {
				menu.querySelector( 'summary' ).focus();
			}
		}
	} );
}
